import TableComponentWithDialog from "../TableComponentWithDialog";
import { labels } from "../../../../localization/labels";
import { paths } from "../../../paths";

class AdvancedSearchComponent extends TableComponentWithDialog {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      advancedSearchParams: {}
    };
  }

  resetComponent() {
    this.setState({ advancedSearchParams: {} });

    super.resetComponent();
  }

  handleAdvancedSearchShow = () => {
    const advancedSearchParams = this.getAdvancedSearchParams();
    this.changePath(paths.ADVANCED_SEARCH, labels.advancedSearch, {
      advancedSearchParams: advancedSearchParams
    });
  };

  getAdvancedSearchParams = () => {
    throw new Error(
      "You have to implement the method setAdvancedSearchParams!"
    );
  };

  adjustPageInfo(pageInfo) {
    const { advancedSearchParams } = this.state;
    if (advancedSearchParams) {
      Object.keys(advancedSearchParams).forEach(function (key) {
        const advancedSearchfilter = advancedSearchParams[key];
        if (
          advancedSearchfilter.filterVal ||
          (Array.isArray(advancedSearchfilter.filterVal) &&
            advancedSearchfilter.filterVal.length > 0)
        ) {
          var filter = {
            filterVal: undefined,
            filterType: undefined,
            comparator: undefined,
            nestedId: undefined
          };
          if (advancedSearchfilter.nestedId) {
            const filterValueIds = [];
            Object.keys(advancedSearchfilter.filterVal).forEach(function (
              valKey
            ) {
              const filterObject = advancedSearchfilter.filterVal[valKey];
              filterValueIds.push(filterObject[advancedSearchfilter.nestedId]);
            });
            filter.filterVal = filterValueIds;
          } else {
            filter.filterVal = advancedSearchfilter.filterVal;
          }
          filter.filterType = advancedSearchfilter.filterType;
          filter.comparator = advancedSearchfilter.comparator;
          pageInfo.filters[key] = filter;
        }
      });
    }
  }

  deleteAdvancedSearchParams = () => {
    this.removeAdvancedSearchParamsFromFilter(this.state.pageInfo);
    this.state.advancedSearchParams = undefined;
    this.startLoading(this.state.pageInfo, this.sortInfo);
  };

  renderProps() {
    return {
      ...super.renderProps(),
      advancedSearchParams: this.state.advancedSearchParams,
      deleteAdvancedSearchParams: this.deleteAdvancedSearchParams,
      handleAdvancedSearchShow: this.handleAdvancedSearchShow
    };
  }
}

export default AdvancedSearchComponent;
